/**
 * WordPress dependencies
 */
import { store, getContext, getElement } from '@wordpress/interactivity';

const { state } = store( 'webx-sticky-header', {
    state: {
        isSticky: false,
        isTransparent: false,
        headerHeight: 0,
    },
    actions: {
        toggleSticky: () => {
            const context = getContext();
            const headerElement = getElement().ref;
            const currentScroll = window.scrollY;
            const hasClassTransparent = context.hasClassTransparent;
            if ( currentScroll > 0 ) {
                // Apply sticky styles when scrolling
                // Set header height if not transparent
                if ( ! hasClassTransparent ) {
                    state.headerHeight = `${ headerElement.clientHeight }px`;
                }
                state.isSticky = true;
                state.isTransparent = false;
            } else {
                // Reset styles for non-sticky state
                state.isSticky = false;
                state.isTransparent = context.hasClassTransparent;
                state.headerHeight = 0;
            }
        },
    },
} );
